<template>
	<div id="app" class="select-none">
		<router-view></router-view>

		
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				
			}
		},
		components: {},
		mounted() {
			document.addEventListener('keydown', function(event) {
				if (event.key === 'F12') {
					event.preventDefault();
				}
				if (event.key === 'F5') {
					event.preventDefault();
				}
			});
			document.addEventListener('contextmenu', function(e) {
				e.preventDefault();
			});
		},
		mounted() {
			
		},
		methods: {

		

		}
	}
</script>

<style>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	* {
		margin: 0;
		padding: 0;
	}

	#app {
		/* color: #545C63; */
		/* font-size: 14px; */
	}

	img {
		margin: 0;
		display: block;
	}

	input:focus {
		outline: none;
	}

	.yw-text-cut-1 {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: break-word;
		white-space: normal !important;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	/* 隐藏文字显示 ...换行 */
	.yw-text-cut-2 {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.yw-text-cut-3 {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: break-word;
		white-space: normal !important;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.bB-01 {
		border-bottom: 1px solid rgba(216, 216, 216, 0.3);
	}



	.bB-02 {
		border-bottom: 1px solid #E8E8E8;
	}

	.bB-03 {
		border-bottom: 1px solid #D1D1D1;
	}

	.bB-04 {
		border-bottom: 1px solid #E0E0E0;
	}

	.bL-01 {
		border-left: 1px solid rgba(209, 209, 209, 1);
	}



	.border-01 {
		border: 2px solid rgba(247, 248, 251, 1)
	}

	.border-02 {
		border: 2px solid #BBBBBB
	}


	.shadow-01 {
		box-shadow: 0px 2px 6px 0px rgba(95, 101, 105, 0.4);
	}

	.shadow-02 {
		box-shadow: 0px 2px 6px 0px rgba(58, 150, 194, 0.21);
	}
	

	
</style>